import {
  GET_SIGNATURE_REQUEST_BEGIN,
  GET_SIGNATURE_REQUEST_SUCCESS,
  GET_SIGNATURE_REQUEST_FAILURE,
  SET_AGREED_DOCUMENTS,
  GET_PAGES_BEGIN,
  GET_PAGES_SUCCESS,
  GET_PAGES_FAILURE,
  GET_EXPIRE_PAGE_BEGIN,
  GET_EXPIRE_PAGE_SUCCESS,
  GET_EXPIRE_PAGE_FAILURE,
} from '../actions/actions'

/*
 * Initial state.
 */

const initialState = {
  agreedAllDocuments: false,
  documentsIds: [],
  error: null,
  initialDocumentsIds: [],
  isLoading: false,
  pages: {},
  signatureRequest: {},
  signEmpty: true,
  expire_page: '',
}

/*
 * Reducer.
 */
export default function (state = initialState, action) {
  switch (action.type) {
    case GET_SIGNATURE_REQUEST_BEGIN:
      return {
        ...state,
        isLoading: true,
        error: null,
      }

    case GET_SIGNATURE_REQUEST_SUCCESS:
      let initialDocId = JSON.parse(action.payload.data.data.attributes.field_waivers)
      return {
        ...state,
        isLoading: false,
        signatureRequest: action.payload.data.data,
        initialDocumentsIds: Object.keys(initialDocId),
      }

    case GET_SIGNATURE_REQUEST_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
        signatureRequest: {},
      }
    case SET_AGREED_DOCUMENTS:
      let documentsIds = initialState.documentsIds

      if (documentsIds.indexOf(action.payload) === -1) {
        documentsIds.push(action.payload)
      }

      return {
        ...state,
        agreedAllDocuments: JSON.stringify(state.initialDocumentsIds.sort()) === JSON.stringify(documentsIds.sort()),
        documentsIds: documentsIds,
        initialDocumentsIds: state.initialDocumentsIds,
      }

    case GET_PAGES_BEGIN:
      return {
        ...state,
        isLoading: true,
        error: null,
      }

    case GET_PAGES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        pages: action.payload.data,
      }

    case GET_PAGES_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
        pages: {},
      }
    case GET_EXPIRE_PAGE_BEGIN:
      return {
        ...state,
        isLoading: true,
        error: null,
      }

    case GET_EXPIRE_PAGE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        expire_page: action.payload.data.expire_page,
      }

    case GET_EXPIRE_PAGE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
        expire_page: '',
      }

    default:
      return state
  }
}
